// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-icon.copy-icon[data-v-ca265dfc]:hover {\n  color: var(--v-primary-base) !important;\n}\n.mew-component-mew-copy .v-icon.v-icon.v-icon--link[data-v-ca265dfc] {\n  color: var(--v-textMediumWhite-base) !important;\n}", ""]);
// Exports
module.exports = exports;
